export default ({ indicators }) => ({
  '@keyframes rotate': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',

    '&::before': {
      content: '""',
      width: ({ size }) => size || indicators.loadingSize,
      height: ({ size }) => size || indicators.loadingSize,
      border: [indicators.loadingWidth, 'solid'],
      borderLeftColor: 'transparent',
      borderRadius: '50%',
      color: indicators.loadingColor,
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationName: '$rotate',
      animationTimingFunction: 'linear'
    }
  }
});
